import ApiEndpointConstants from "../constants/ApiEndpointConstants";
import api from "./API";

export const getTieZiCommentList = (page, per_page, tieziid) => {
  return api.post(`${ApiEndpointConstants.GET_TIEZI_COMMENT_LIST}`, {
    page,
    per_page,
    tieziid,
  });
};
